/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";
import MuiDivider from "@mui/material/Divider";

import { TableRow } from "@mui/material";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";

// Data
import data from "layouts/predictions/Predictions/data";

function Predictions() {
  const { columns, rows } = data();
  console.log(rows)
  return (
    <Card style={{padding:"2rem"}}>
      <MDBox>
      <MDBox  component="thead">
        <TableRow>
          {columns.map((column, key) => (
            <DataTableHeadCell
              key={key}
              width={column['width']}
              sorted={false}
            >
              {column["Header"]}
            </DataTableHeadCell>
        
          ))}
         </TableRow>
        </MDBox>
        {rows.map((row => (
          <>
          <MDBox display="flex" justifyContent="space-between" mt={3}>
            <MDBox width="50%">
            {row.description}
            </MDBox>
            <MDBox>
              {row.budget}
            </MDBox>
            {row.completion}
          </MDBox>
          <MuiDivider />
          </>
        )))}
      </MDBox>
    </Card>
  );
}

export default Predictions;
